/**
 * Ryan O'Dowd
 * 2024-03-01
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({colors, isDarkMode}) => {
  return {
    container: {
      display: 'flex',
      flexDirection: 'column',
    },
    lectureText: {
      color: isDarkMode ? colors.primaryExtraLight : colors.primaryExtraDark,
      whiteSpace: 'pre-wrap',
    },
  };
};

export default getStyles;
